import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { RequestStatus, stores } from 'mobx-store';

import GeneralTableComponent from 'components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import { translate } from 'helperFunctions/translation';
import { TableCellTypes } from 'components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import { Button, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import { LeadStatus, RedemptionMethod, DEFAULT_PAGE_SIZE } from 'mobx-store/stores/leadStore';
import GeneralViewModal from 'components/modals/generalViewModal';
import SnackBarComponent from 'components/SnackBarComponent/SnackBarComponent';
import { ROLES } from 'components/NavBar/NavigationItems/routes';
import { DatePicker } from '@material-ui/pickers';
import moment, { Moment } from 'moment';



const LeadScreen = observer(() => {
    const { leadStore } = stores;
    const [toEditLeadId, setToEditLeadId] = useState<number | undefined>(undefined);

    useEffect(() => {
        leadStore.getLeads();
    }, []);


    const validateDateRange = () => {
        const startDate = leadStore.filter.startDate;
        const endDate = leadStore.filter.endDate;

        if (!startDate || !endDate) {
            return { valid: false, message: "Both dates must be provided." };
        }

        const start = moment(startDate);
        const end = moment(endDate);

        // Check if start date is before end date
        if (start.isAfter(end)) {
            return { valid: false, message: "Start date must be before end date." };
        }

        // Check if the range exceeds 7 days
        const duration = end.diff(start, 'days');
        if (duration > 31) {
            return { valid: false, message: "The date range must not exceed 31 days." };
        }

        return { valid: true, message: "Date range is valid." };
    };

    const handleEditLead = (index: number) => {
        setToEditLeadId(leadStore.leads[index].id);
    }
    const tableHeaders = [
        {
            title: 'name',
        },
        {
            title: 'phone 1',
        },
        {
            title: 'phone 2',
        },
        {
            title: 'otp',
        },
        {
            title: 'points',
        },
        {
            title: 'winning date',
        },
        {
            title: 'redemption method',
        },
        {
            title: 'membership Id',
        },
        {
            title: 'edit',
        }

    ];
    const cellTypes: TableCellTypes[] = [
        {
            cellType: 'Text',
            key: 'name',
        },
        {
            cellType: 'Text',
            key: 'phonenumber1',
        },
        {
            cellType: 'Text',
            key: 'phonenumber2',
        },
        {
            cellType: 'Text',
            key: 'otp'
        },
        {
            cellType: 'Text',
            key: 'points',
        },
        {
            cellType: 'Text',
            key: 'winningDate',
        },
        {
            cellType: 'Text',
            key: 'redemptionMethod',
        },
        {
            cellType: 'Text',
            key: 'membershipId',
        },
        {
            cellType: 'Button',
            key: 'edit',
            onClick: handleEditLead,
        },
    ];

    const leftArrowClicked = () => {
        leadStore.pagination.page -= 1;
        leadStore.getLeads();

    };
    const rightArrowClicked = () => {
        leadStore.pagination.page += 1;
        leadStore.getLeads();

    };
    const handleFilter = () => {
        if (leadStore.filter.status === LeadStatus.CalimedPoints) {
            const { message, valid } = validateDateRange();
            if (!valid) {
                alert(message)
                return;
            }
        }
        leadStore.getLeads();
    }
    const handleCsvFilter = () => {
        if (leadStore.filter.status === LeadStatus.CalimedPoints) {
            const { message, valid } = validateDateRange();
            if (!valid) {
                alert(message)
                return;
            }
        }
        leadStore.getLeadsCsv();
        leadStore.getLeads();
    }


    const UpdateLeadModal = () => {
        const [membershipId, setMembershipId] = useState<string>('');
        const [redemptionMethod, setRedemptionMethod] = useState<RedemptionMethod | ''>('');

        const handleMembershipIdChange = (event: any) => {
            setMembershipId(event.target.value);
        };

        const handleRedemptionMethodChange = (event: any) => {
            setRedemptionMethod(event.target.value);
        };

        const handleSubmit = async (event: any) => {
            event.preventDefault();
            // Handle the form submission logic here
            if (!redemptionMethod) {
                alert('Redemption method is required');
                return;
            }
            if (toEditLeadId !== undefined && !isNaN(toEditLeadId)) {
                try {
                    await leadStore.updateLead(toEditLeadId, { membershipId, redemptionMethod });
                    setToEditLeadId(undefined);
                    leadStore.getLeads();
                    SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
                    }), 3000, 'success');
                } catch (error) {
                    SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
                    }), 3000, 'error');
                }
            }
        };

        return (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
                <Grid container spacing={2} alignItems="flex-start">
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Membership ID"
                            variant="outlined"
                            value={membershipId}
                            onChange={handleMembershipIdChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel>Redemption Method</InputLabel>
                            <Select
                                value={redemptionMethod}
                                onChange={handleRedemptionMethodChange}
                                label="Redemption Method"
                            >
                                {Object.keys(RedemptionMethod).map(r => <MenuItem value={r}>{r}</MenuItem>)}

                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} >
                        <Button type="submit" color="primary" variant="contained">
                            {leadStore.leadState === RequestStatus.LOADING ? <CircularProgress size="1.4rem" color="inherit" /> : 'Save'}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        );
    }
    return (
        <div>
            {ROLES.LEAD_VIEWER !== stores.authStore.userData.role.title && (
                <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginBottom: "20px" }}
                >
                    <Grid item xs={12} sm={8}>
                        <input
                            type="file"
                            accept=".xls,.xlsx"
                            id="lead-upload-input"
                            style={{ display: "none" }}
                            onChange={async (e) => {
                                const file = e.target.files?.[0];
                                if (!file) return;
                                try {
                                    await leadStore.uploadLeadsFile(file);
                                    alert("Leads uploaded successfully!");
                                    // Optionally refresh leads after upload
                                    await leadStore.getLeads();
                                } catch (error) {
                                    alert("Upload failed. Please try again.");
                                }
                            }}
                        />
                        <label htmlFor="lead-upload-input">
                            <Button
                                variant="contained"
                                color="secondary"
                                component="span"
                                disabled={leadStore.uploadState === RequestStatus.LOADING}
                            >
                                {leadStore.uploadState === RequestStatus.LOADING
                                    ? "Uploading..."
                                    : "Upload Excel File"}
                            </Button>
                        </label>
                    </Grid>
                </Grid>
            )}



            <Grid container spacing={2} alignItems="center" style={{ marginBottom: '20px' }}>
                <Grid item xs={12} sm={12}>
                    <TextField
                        label="Search"
                        variant="outlined"
                        value={leadStore.filter.search}
                        onChange={(e) => leadStore.filter.search = e.target.value}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel>Status</InputLabel>
                        <Select
                            value={leadStore.filter.status}
                            onChange={(e) => leadStore.filter.status = e.target.value as LeadStatus}
                            label="Status"
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            {Object.keys(LeadStatus).map(s => <MenuItem value={s}>{translate(s)}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel>Method</InputLabel>
                        <Select
                            value={leadStore.filter.method}
                            onChange={(e) => leadStore.filter.method = e.target.value as RedemptionMethod}
                            label="Method"
                        >
                            <MenuItem value="">None</MenuItem>
                            {Object.keys(RedemptionMethod).map(r => <MenuItem value={r}>{r}</MenuItem>)}

                        </Select>
                    </FormControl>
                </Grid>
                {leadStore.filter.status === LeadStatus.CalimedPoints && (
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <FormControl variant="outlined" fullWidth>
                                <DatePicker
                                    // style={{ width: '100%' }}
                                    label="From Date"
                                    value={leadStore.filter.startDate}
                                    onChange={(date) => leadStore.filter.startDate = moment(new Date(date!.toString())).startOf('day').toISOString()} // Type should be compatible
                                // renderInput={(props) => <TextField {...props} />}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl variant="outlined" fullWidth>
                                <DatePicker
                                    // style={{ width: '100%' }}
                                    label="To Date"
                                    value={leadStore.filter.endDate}
                                    onChange={(date) => leadStore.filter.endDate = moment(new Date(date!.toString())).toISOString()} // Type should b
                                // renderInput={(props) => <TextField {...props} />}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                )}

                <Grid item xs={12} container justify='flex-end'>
                    <Button variant="contained" color="primary" onClick={handleFilter}>
                        Apply Filters
                    </Button>
                    <div style={{ margin: '0 5px' }} />
                    {ROLES.LEAD_VIEWER !== stores.authStore.userData.role.title && leadStore.filter.status === LeadStatus.CalimedPoints && (<Button variant="outlined" color="primary" onClick={handleCsvFilter}>
                        Filters & Download Csv
                    </Button>)}
                </Grid>
            </Grid>


            <GeneralTableComponent
                title={'Leads'}
                emptyMessage={translate('LeadsEmptyTableMessage', {
                })}
                tableHeader={tableHeaders}
                tableData={leadStore.leads.map(lead => ({ ...lead, edit: 'Edit', }))}
                tableCellTypes={cellTypes}
                loading={false}
                hadPagination
                paginationAction={{
                    handleClickLeftArrow: leftArrowClicked,
                    handleClickRightArrow: rightArrowClicked,
                    pageNumber: leadStore.pagination.page,
                    totalNumberOfPages: Math.ceil(leadStore.pagination.total / DEFAULT_PAGE_SIZE),
                }}
                loadingStatus={[
                    leadStore.leadsState
                ]}
            />
            <GeneralViewModal
                open={toEditLeadId !== undefined && !isNaN(toEditLeadId)}
                content={UpdateLeadModal()}
                title={''}
                handleClose={() => setToEditLeadId(undefined)}
            />
        </div>
    );
});

export default LeadScreen;
